import { reducer as eMarketingReducer } from './eMarketing.slice';

export default eMarketingReducer;
